export default "precision mediump float;\n#define GLSLIFY 1\n \nvarying vec4 fragColour;\n \nvoid main() {\n   gl_FragColor = fragColour;\n}\n";